import { isMobileOrTablet } from '../app-utils/mobile-utils';

/** Handle chat button when Filter is opened in mobile */
export const handleFilters = () => {
  const customButton = document.getElementById('caHelpButton');

  if (isMobileOrTablet() && customButton != null && customButton.classList.contains('caHelpButtonEnabled')) {
    const mobileFilterButton = document.getElementById('mobile-button-filter');
    const closeButton = document.getElementById('mobile-filter-header-close-x');
    const resultsButton = document.getElementById('mobile-filter-footer-close-button');

    const showCustomButton = (isVisible) => {
      customButton.style.visibility = isVisible ? 'visible' : 'hidden';
    };

    mobileFilterButton?.addEventListener('click', () => showCustomButton(false));
    closeButton?.addEventListener('click', () => showCustomButton(true));
    resultsButton?.addEventListener('click', () => showCustomButton(true));
  }
};

export const handleGoogleModal = () => {
  const customButton = document.getElementById('caHelpButton');

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          const googleIframe = document.querySelector('#credential_picker_iframe');
          const cookieModal = document.querySelector('[aria-labelledby="cookie-dialog-title"]');

          const isVisible = googleIframe || cookieModal;

          if (customButton && isMobileOrTablet()) {
            customButton.style.visibility = isVisible ? 'hidden' : 'visible';

            if (isVisible) {
              console.info('Detected target element (iframe or cookie modal) in DOM -- dev');
              observer.disconnect();
              break;
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    console.info('MutationObserver initialized');
  }
};
